import axios from "axios";
import { localServer } from 'xes-code-base/lib/wrapper/vue/http/localServer.js'

const handleResponse = (res) => res.data.data

function fnScanPyVersion() {
  return fetch(localServer.GetHttp() + '/version').then(res => res.json())
}
// 支持code.xesv5.com域名
function fnGetPythonClient() {
  return fetch(window.location.origin + '/api/compilers/get_python_client').then(res => res.json())
}
// 获取喵比特固件，配置跨域以支持后台配题(code.xesv5.com)
function fnGetFirmVersion() {
  // return fetch('https://code.xueersi.com/api/config/hardware?name=hw_pocketcode',{
  //   method: 'GET',
  //   mode: 'cors'
  // }).then(res => res.json())
  return fetch(window.location.origin + '/api/config/hardware?name=hw_pocketcode').then(res => res.json())
}

/**
 * 绑定设备
 */
function fnBindDeviceId(deviceId){
  return axios.post('/api/hdapi/hd/bind', {
    device_id: deviceId
  }).then(res => handleResponse(res))
}
/**
 * 查询设备列表
 */
function fnQueryDevices(){
  return axios.get('/api/hdapi/hd/devices').then(res => handleResponse(res))
}
/**
 * 查询设备是否在线
 */
function fnQueryDeviceState(deviceId){
  return axios.get(`/api/hdapi/hd/state/${deviceId}`).then(res => handleResponse(res))
}

function fnIsPc() {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false
          break
      }
  }
  return flag
}
function fnIsMac () {
  var agent = navigator.userAgent.toLowerCase()
  var isMac = /macintosh|mac os x/i.test(navigator.userAgent)
  if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
    // console.log('这是windows32位系统')
    return false
  }
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    // console.log('这是windows64位系统')
    return false
  }
  if (isMac) {
    // console.log('这是mac系统')
    return true
  }
}

function fnDetectOS(){
  var sUserAgent = navigator.userAgent;
  var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
  var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
  if (isMac) return "mac";
  var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
  if (isUnix) return "Unix";
  var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
  if (isLinux) return "Linux";
  if (isWin) {
      return 'win';
  }
  return "win";
}

// 操作系统版本
function fnGetOperatingSystemInfo() {
  let operatingInfo = navigator.userAgent
  let isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows")
  let isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel")
  if (isMac) return "mac"
  if (isWin) {
      let isWin7 = operatingInfo.indexOf("Windows NT 6.1") > -1 || operatingInfo.indexOf("Windows 7") > -1
      if (isWin7) return "win7"
      let isWin10 = operatingInfo.indexOf("Windows NT 10")!=-1
      if(isWin10) return "win10"
  }
  return "other"
}

export default {
  scanPyVersion: fnScanPyVersion,
  getPythonClient: fnGetPythonClient,
  getFirmVersion: fnGetFirmVersion,
  bindDeviceId: fnBindDeviceId,
  queryDevices: fnQueryDevices,
  queryDeviceState: fnQueryDeviceState,
  isPc: fnIsPc,
  isMac: fnIsMac,
  detectOS: fnDetectOS,
  getOperatingSystemInfo: fnGetOperatingSystemInfo
}

